const initialState = {
    userMessage: null,
    loading: false,
  };
  
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_USER_MESSAGE': {
          return {
              ...state,
              userMessage: action.payload
          }
      }
      case 'TOGGLE_LOADING': {
          return {
              ...state,
              loading: !state.loading
          }
      }
      default: {
        return state;
      }
    }
  };
  
  export default authReducer;